import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { IGraph } from './IGraph';
import { Graph } from './Graph';

export default class GraphResource extends FBaseService {
  public async get(): Promise<Graph[]> {
    const url = '/api/question-graph';

    const response: AxiosResponse = await this.apiClient.get(url);
    const igraphs: IGraph[] = response.data.data;

    const graphs: Graph[] = [];
    igraphs.forEach((sourceGraph: IGraph) => {
      graphs.push(new Graph(sourceGraph));
    });

    return graphs;
  }
}
